import React, { forwardRef } from 'react';

import { Dialog } from 'primereact/dialog';

import { ApiResponse } from 'components/services/interfaces';

import { AssetForEdit } from '../../types/interfaces';
import AssetCard from '../AssetCard/AssetCard';

interface AssetDialogProps {
  dialogVisible: boolean;
  assetData: any;
  onHideAssetCard: () => void;
  handleAdd: (asset: AssetForEdit) => Promise<ApiResponse<AssetForEdit>>;
  handleUpdate: (
    id: string | number,
    updatedAsset: AssetForEdit
  ) => Promise<ApiResponse<AssetForEdit>>;
  closeDialog: () => void;
  assetCardKey: string;
}

const AssetDialog = forwardRef<any, AssetDialogProps>(
  (
    {
      dialogVisible,
      assetData,
      onHideAssetCard,
      handleAdd,
      handleUpdate,
      closeDialog,
      assetCardKey
    },
    ref
  ) => {
    return (
      <Dialog
        header="Карточка объекта"
        visible={dialogVisible}
        style={{ minWidth: '743px', width: '743px', minHeight: 'fit-content' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        maximizable
        modal
        contentStyle={{ minHeight: 'fit-content' }}
        onHide={() => onHideAssetCard()}
      >
        <AssetCard
          key={assetCardKey}
          assetProps={assetData}
          onAdd={handleAdd}
          onUpdate={handleUpdate}
          closeDialog={closeDialog}
          ref={ref}
        />
      </Dialog>
    );
  }
);

AssetDialog.displayName = 'AssetDialog';

export default AssetDialog;
